<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-simple-table>
					<tr v-for="group in groups" :key="group.name">
						<td>{{ group.name }}</td>
						<td class="role-count">
							<tippy>
								<template #trigger>
									{{ group.userHas }} of {{ group.roles.length }}
									<v-icon class="pl-1" color="ocean" small>far fa-eye</v-icon>
								</template>

								<v-simple-table dark dense>
									<tr v-for="role in group.roles" :key="role">
										<td>{{ role }}</td>
										<td v-if="userHasRole(role)">
											<v-icon color="green" small>fas fa-check</v-icon>
										</td>
										<td v-else>
											<v-icon color="rust-red" small>fas fa-times</v-icon>
										</td>
									</tr>
								</v-simple-table>
							</tippy>
						</td>
						<td v-if="canEdit" class="apply">
							<v-btn
								outlined
								text
								:disabled="group.userHas === group.roles.length"
								@click="confirmGroup(group)"
								>Apply</v-btn
							>
						</td>
					</tr>
				</v-simple-table>
			</v-col>
		</v-row>

		<v-row v-if="advancedEdit" justify="end" no-gutters>
			<v-btn text @click="$emit('toggle')">Advanced</v-btn>
		</v-row>

		<v-dialog v-model="confirmDialog" width="350px">
			<v-card v-if="selectedGroup">
				<v-card-title> Apply {{ selectedGroup.name }} group </v-card-title>
				<v-card-text class="pb-2">
					<span>
						Applying this group will add the following roles to the user:
					</span>
				</v-card-text>
				<v-simple-table class="confirm-role-table pa-2" dense>
					<tr v-for="(role, i) in confirmRolesDifference()" :key="i">
						<td v-text="role" />
						<td class="apply">
							<v-icon color="green" small>fas fa-check</v-icon>
						</td>
					</tr>
				</v-simple-table>
				<v-card-actions class="justify-end">
					<v-btn text @click="confirmDialog = false">Cancel</v-btn>
					<v-btn :loading="loading" color="success" @click="applyRoleGroup">Confirm</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<style lang="scss" scoped>
.role-count {
	min-width: 110px;
	text-align: center;
}

.apply {
	text-align: right;
}

.confirm-role-table {
	max-height: 40vh;
	overflow-y: auto;
}
</style>

<script>
import _ from "lodash";

import config from "@/../public/config.json";
import { mapActions, mapGetters } from "vuex";

export default {
	data() {
		return {
			loading: false,
			selectedGroup: null,
			confirmDialog: false,
		};
	},

	computed: {
		...mapGetters("userEdit", ["canEdit", "advancedEdit"]),

		userRoles() {
			return _.map(this.$store.getters["userEdit/roles"], "name");
		},

		allRoles() {
			return Object.values(this.$store.getters["roles/roles"]);
		},

		groups() {
			return _.map(config.roleGroups, (group, name) => {
				const groupRoles = (group.roles || []).sort();
				const userHas = _.intersection(groupRoles, this.userRoles).length;

				return {
					name,
					roles: groupRoles,
					userHas,
				};
			});
		},
	},

	methods: {
		...mapActions("userEdit", ["changeUserAssociationRole"]),

		userHasRole(role) {
			return _.includes(this.userRoles, role);
		},

		getRolesIds(roles) {
			return this.allRoles
				.filter((role) => roles.includes(role.name))
				.map((role) => role.id);
		},

		confirmGroup(group) {
			this.selectedGroup = group;
			this.confirmDialog = true;
		},

		confirmRolesDifference() {
			return _.difference(this.selectedGroup.roles, this.userRoles);
		},

		async applyRoleGroup() {
			if (this.loading) return;
			this.loading = true;
			const roles = this.confirmRolesDifference();
			const itemId = this.getRolesIds(roles);
			try {
				await this.changeUserAssociationRole({
					method: "addUserRole",
					userId: this.$route.params.userId,
					itemId,
				});
				this.confirmDialog = false;
			} catch (err) {
				console.warn(err);
			}
			this.loading = false;
		},
	},
};
</script>
